module.exports = __webpack_public_path__ + "img/电子与智能化工程专业承包贰级资质证书.18ab8084.png";